<!--
  appendTo="body" es obligatorio: el diálogo vive dentro de .info-card, que tiene :hover{transform}.
  Sin dismissableMask a propósito: hay trabajo sin guardar (excepción de wizard, styleguide §3.12).
-->
<p-dialog
  [(visible)]="visible"
  (onHide)="hide()"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '880px', maxWidth: '96vw' }"
  styleClass="apply-preview-dialog"
>
  <ng-template pTemplate="header">
    <span class="ap-title">{{ titles[mode] }}</span>
    <button type="button" class="ap-close" (click)="requestHide()" aria-label="Cerrar"><i class="pi pi-times"></i></button>
  </ng-template>

  <!-- 1 · Qué se va a mover -->
  <section class="ap-step">
    <div class="ap-step-head">
      <span class="ap-step-num">1</span>
      <h4>{{ mode === 'CANCEL' ? 'Qué se cancela' : 'Qué pago se aplica' }}</h4>
    </div>
    <ng-container *ngIf="mode !== 'CANCEL'">
      <!-- optionLabel: nombre accesible del dropdown (styleguide §3.13 regla 3); las plantillas cubren lo visible -->
      <label for="apPayment" *ngIf="payments.length > 1">Pago</label>
      <p-dropdown
        *ngIf="payments.length > 1"
        inputId="apPayment"
        [options]="payments"
        optionLabel="trackingKey"
        optionValue="_id"
        [(ngModel)]="paymentId"
        (onChange)="onPaymentChange()"
        appendTo="body"
        styleClass="w-full"
      >
        <ng-template pTemplate="selectedItem" let-p
          ><span class="pd-mono">{{ p.trackingKey }}</span> · {{ p.pendingToApply | currency }} · pagó
          {{ p.paidOn | date: 'dd/MM/yyyy' : 'UTC' }}</ng-template
        >
        <ng-template pTemplate="item" let-p
          ><span class="pd-mono">{{ p.trackingKey }}</span> · {{ p.pendingToApply | currency }} · pagó
          {{ p.paidOn | date: 'dd/MM/yyyy' : 'UTC' }}</ng-template
        >
      </p-dropdown>
      <!-- Monto a aplicar (diseño aprobado, primer campo): por omisión todo lo disponible del pago -->
      <div class="field" *ngIf="payment as p">
        <label for="apAmount">Monto a aplicar</label>
        <p-inputNumber
          inputId="apAmount"
          [(ngModel)]="amount"
          (onInput)="invalidatePreview()"
          mode="currency"
          currency="MXN"
          locale="es-MX"
          [min]="0.01"
          [max]="p.pendingToApply"
          styleClass="w-full"
        ></p-inputNumber>
        <small class="text-color-secondary"
          >Por omisión, todo lo disponible del pago ({{ p.pendingToApply | currency }}). Un monto menor deja el resto disponible en el pago,
          por ejemplo para otro arrendamiento del mismo cliente.</small
        >
      </div>
      <div class="ap-context" *ngIf="payment as p">
        <div class="compact-item">
          <span class="label">Clave</span><span class="value pd-mono">{{ p.trackingKey }}</span>
        </div>
        <div class="compact-item">
          <span class="label">Disponible</span><span class="value success">{{ p.pendingToApply | currency }}</span>
        </div>
        <div class="compact-item">
          <span class="label">Pagó el cliente</span><span class="value">{{ p.paidOn | date: 'dd/MM/yyyy' : 'UTC' }}</span
          ><small class="text-color-secondary"
            >La mora corre desde el día siguiente al vencimiento y se corta en esta fecha, no en la del registro.</small
          >
        </div>
        <div class="compact-item">
          <span class="label">Orden de cobro</span
          ><span class="value" *ngIf="nextToCollect != null; else fifoGenerico"
            >La primera letra abierta es la {{ nextToCollect }} ({{ nextToCollectDate | date: 'dd/MM/yyyy' : 'UTC' }}). No se puede saltar
            una letra con saldo.</span
          ><ng-template #fifoGenerico
            ><span class="value">De la letra más antigua con saldo a la más reciente. No se elige letra.</span></ng-template
          >
        </div>
      </div>
    </ng-container>
    <div class="ap-context" *ngIf="mode === 'CANCEL' && application">
      <div class="compact-item">
        <span class="label">Aplicación</span
        ><span class="value"
          ><ng-container *ngIf="(application.letters?.length ?? 0) > 1; else unaLetra"
            >Letras {{ application.letters!.join(', ') }} · </ng-container
          ><ng-template #unaLetra
            ><ng-container *ngIf="application.n !== null && application.n !== undefined"
              >Letra {{ application.n }} ·
            </ng-container></ng-template
          >{{ application.amount | currency }}</span
        >
      </div>
      <div class="compact-item">
        <span class="label">Pago</span><span class="value pd-mono">{{ payment?.trackingKey }}</span>
      </div>
    </div>
  </section>

  <!-- 2 · Impacto -->
  <!-- Paso intermedio: solo aparece cuando el cliente tiene más de un arrendamiento activo. Con uno solo
	     no hay reparto que decidir y pedirlo sería un paso vacío. -->
  <section class="ap-step" *ngIf="showsSelector">
    <div class="ap-step-head">
      <span class="ap-step-num">2</span>
      <h4>A qué arrendamientos va</h4>
    </div>
    <app-lease-distribution-selector
      [leases]="clientLeases"
      [amount]="amount || 0"
      [asOf]="payment?.paidOn || null"
      [preselectedLeaseId]="leaseId"
      [disabled]="saving"
      (distributionChange)="onDistributionChange($event)"
    >
    </app-lease-distribution-selector>
  </section>

  <section class="ap-step">
    <div class="ap-step-head">
      <span class="ap-step-num">{{ showsSelector ? 3 : 2 }}</span>
      <h4>Revisa el impacto</h4>
    </div>
    <div class="ap-preview-cta" *ngIf="!preview">
      <span><strong>Nada se ha escrito todavía.</strong> El cálculo corre el mismo código que la aplicación y luego lo descarta.</span>
      <button
        pButton
        type="button"
        label="Previsualizar impacto"
        icon="fa-solid fa-calculator"
        (click)="requestPreview()"
        [disabled]="!canPreview || previewing"
        [loading]="previewing"
      ></button>
    </div>
    <!-- El error, en palabras: qué pasó y cómo sigue. El texto del backend se conserva abajo como
		     detalle técnico, para quien tenga que reportarlo. -->
    <div class="ap-warn is-error" *ngIf="previewErrorExplained as err">
      <i class="pi pi-times-circle"></i>
      <div>
        <strong>{{ err.titulo }}</strong>
        <span>{{ err.que }}</span>
        <span class="ap-error-next"><i class="pi pi-arrow-right"></i> {{ err.comoSigo }}</span>
        <span class="ap-error-raw" *ngIf="err.detalle">Detalle técnico: {{ err.detalle }}</span>
      </div>
    </div>

    <!-- Encabezado del plan: una sola declaración para la tabla y para su esqueleto. «Estado» y
	     «Queda» son dos columnas y no una: el chip y el saldo se pisaban dentro de la misma celda. -->
    <ng-template #cabeceraPlan>
      <tr>
        <th *ngIf="showLeaseColumn">Arrendamiento</th>
        <th>Letra</th>
        <th class="text-right">Interés</th>
        <th class="text-right">Mora</th>
        <th class="text-right">Accesorios</th>
        <th class="text-right">Capital</th>
        <th class="text-right">IVA</th>
        <th class="text-right">Aplicado</th>
        <th class="text-center">Estado</th>
        <th class="text-right">Queda</th>
        <th>Registro tardío</th>
      </tr>
    </ng-template>

    <!-- Mientras corre la previsualización: la forma del plan que viene. El botón girando no decía
		     qué se está calculando, y el dry-run abre una transacción contra Mongo —no es instantáneo. -->
    <div class="table-container ap-sk" *ngIf="previewing" aria-busy="true" aria-label="Calculando el impacto">
      <table class="ap-plan">
        <thead>
          <ng-container *ngIf="mode !== 'CANCEL'" [ngTemplateOutlet]="cabeceraPlan"></ng-container>
          <tr *ngIf="mode === 'CANCEL'">
            <th>Letra</th>
            <th>Antes</th>
            <th>Después</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of [1, 2, 3]" [ngClass]="'sk-fade-' + f">
            <td><p-skeleton height="0.8rem" width="1.5rem"></p-skeleton></td>
            <td *ngFor="let c of mode === 'CANCEL' ? [1, 2] : [1, 2, 3, 4, 5, 6, 7, 8, 9]">
              <p-skeleton height="0.8rem" width="4rem"></p-skeleton>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-container *ngIf="preview">
      <!-- Aplicar / residual: plan por letra y concepto (PRD §7.2 ApplyPreviewResult) -->
      <div class="table-container" *ngIf="mode !== 'CANCEL'">
        <table class="ap-plan">
          <thead>
            <ng-container *ngTemplateOutlet="cabeceraPlan"></ng-container>
          </thead>
          <tbody>
            <tr *ngFor="let row of preview.plan">
              <td *ngIf="showLeaseColumn" class="pd-mono">
                {{ folioOf(row.leaseId) }}<br /><small *ngIf="row.fromRedistribution" class="text-color-secondary">lo movió el motor</small>
              </td>
              <td>{{ row.n }}</td>
              <td class="text-right">{{ row.byConcept.interest | currency }}</td>
              <td class="text-right">
                {{ row.byConcept.moratoriums | currency }}
                <small *ngIf="row.moraAsOfPayment" class="text-color-secondary"
                  >de {{ row.moraAsOfPayment | currency }} al día del pago</small
                >
              </td>
              <td class="text-right">{{ row.byConcept.accessories | currency }}</td>
              <td class="text-right">{{ row.byConcept.capital | currency }}</td>
              <td class="text-right">{{ row.byConcept.inputIva | currency }}</td>
              <td class="text-right font-bold">{{ applied(row) | currency }}</td>
              <td class="text-center">
                <p-tag
                  [value]="resultingLabels[row.resulting.status] || row.resulting.status"
                  [severity]="row.resulting.status === 'PAID' ? 'success' : 'warning'"
                ></p-tag>
              </td>
              <td class="text-right">{{ row.resulting.pending | currency }}</td>
              <td>
                <span *ngIf="row.lateRegistration" class="enf-chip"
                  >{{ row.lateRegistration.days }} d · no se cobran {{ row.lateRegistration.delta | currency }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ap-leftover" *ngIf="preview.leftover > 0">
          <i class="pi pi-info-circle"></i> Sobrante que queda disponible en el pago: <strong>{{ preview.leftover | currency }}</strong>
        </div>
      </div>

      <!-- Cancelar: letras que se reabren, pago, facturas y REP (PRD §7.2 CancelPreviewResult) -->
      <ng-container *ngIf="mode === 'CANCEL'">
        <div class="ap-impact">
          <div class="ap-impact-row" *ngFor="let r of preview.reopened">
            <span>Letra {{ r.n }}</span
            ><span>{{ resultingLabels[r.before.status] || r.before.status }} · {{ r.before.pending | currency }}</span
            ><i class="fa-solid fa-arrow-right-long"></i
            ><span>{{ resultingLabels[r.after.status] || r.after.status }} · {{ r.after.pending | currency }}</span>
          </div>
          <div class="ap-impact-row">
            <span>Disponible del pago</span><span>{{ preview.payment.before.pendingToApply | currency }}</span
            ><i class="fa-solid fa-arrow-right-long"></i><span>{{ preview.payment.after.pendingToApply | currency }}</span>
          </div>
          <div class="ap-impact-row" *ngFor="let inv of preview.invoices">
            <span class="pd-mono">{{ inv.folioFiscal }}</span
            ><span>vuelve a {{ inv.willRevertTo }}</span
            ><span *ngIf="inv.complementsToInvalidate">· {{ inv.complementsToInvalidate }} REP a invalidar</span>
          </div>
        </div>
      </ng-container>

      <!-- Advertencias: cada bloqueante se confirma por separado (un código por decisión) -->
      <div class="ap-warnings" *ngIf="preview.warnings?.length">
        <div class="ap-warn" *ngFor="let w of preview.warnings" [class.is-blocking]="w.blocking">
          <i class="pi" [ngClass]="w.blocking ? 'pi-exclamation-triangle' : 'pi-info-circle'"></i>
          <div>
            <strong>{{ warningLabels[w.code] || w.code }}</strong>
            <span>{{ w.message }}</span>
            <div class="field-checkbox" *ngIf="w.blocking">
              <p-checkbox [(ngModel)]="confirmations[w.code]" [binary]="true" [inputId]="'ap-warn-' + w.code"></p-checkbox>
              <label [for]="'ap-warn-' + w.code">Entiendo y confirmo</label>
            </div>
          </div>
        </div>
      </div>
      <button
        pButton
        type="button"
        label="Volver a calcular"
        icon="fa-solid fa-arrow-rotate-left"
        class="p-button-text p-button-sm"
        (click)="invalidatePreview()"
        [disabled]="saving"
      ></button>
    </ng-container>
  </section>

  <!-- 3 · Motivo: solo cancelar -->
  <section class="ap-step" *ngIf="preview && mode === 'CANCEL'">
    <div class="ap-step-head">
      <span class="ap-step-num">3</span>
      <h4>Motivo de la cancelación <span class="ap-req">obligatorio</span></h4>
    </div>
    <!-- label real, no solo placeholder: el nombre accesible del control (SKILL §1, checklist §7) -->
    <div class="field ap-reason">
      <label for="apReason">Motivo</label>
      <textarea
        id="apReason"
        pInputTextarea
        [(ngModel)]="reason"
        rows="3"
        [maxlength]="500"
        placeholder="Por qué se cancela. Queda en la Bitácora del pago y del arrendamiento."
      ></textarea>
    </div>
  </section>

  <ng-template pTemplate="footer">
    <ng-container *ngIf="confirmingClose; else footerNormal">
      <span class="ap-discard-msg"><i class="pi pi-exclamation-triangle"></i> Se perderá lo capturado. ¿Cerrar de todos modos?</span>
      <button pButton type="button" label="Seguir aquí" class="p-button-text" (click)="cancelClose()"></button>
      <button pButton type="button" label="Sí, cerrar" icon="pi pi-times" class="p-button-danger" (click)="hide()"></button>
    </ng-container>
    <ng-template #footerNormal>
      <button pButton type="button" label="Cancelar" class="p-button-text" (click)="requestHide()" [disabled]="saving"></button>
      <!-- El botón lleva el monto del plan («Aplicar $X», diseño aprobado); antes de previsualizar dice solo «Aplicar» -->
      <button
        pButton
        type="button"
        [label]="mode === 'CANCEL' ? 'Confirmar cancelación' : preview ? 'Aplicar ' + (totalPlan | currency) : 'Aplicar'"
        icon="pi pi-check"
        [class.p-button-danger]="mode === 'CANCEL'"
        (click)="apply()"
        [disabled]="!canApply"
        [loading]="saving"
        [pTooltip]="
          !preview
            ? 'Primero previsualiza el impacto'
            : !allWarningsConfirmed
              ? 'Faltan advertencias por confirmar'
              : mode === 'CANCEL' && !reason.trim()
                ? 'Captura el motivo'
                : ''
        "
        tooltipPosition="top"
      ></button>
    </ng-template>
  </ng-template>
</p-dialog>
